import { render, staticRenderFns } from "./TaxPlanAddEdit.vue?vue&type=template&id=36e9ee1a"
import script from "./TaxPlanAddEdit.vue?vue&type=script&lang=js"
export * from "./TaxPlanAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports